// External
import React from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import _ from "lodash";

// Design system
import UIModal from "UIComponents/UIModal";
import { PageHeader, DSProvider } from "@toddle-edu/ds-web";

// Relative
import { closeInternalToolModal } from "./modules/InternalToolsModalActions";
import ViewAndMigrateTermAssociatedData from "./components/ViewAndMigrateTermAssociatedData/ViewAndMigrateTermAssociatedData";
import RatingLogsModal from "./components/RatingLogsModal/RatingLogsModal";
import RemarkLogsModal from "./components/RemarkLogsModal/RemarkLogsModal";
import TemplateLogsModal from "./components/TemplateLogsModal/TemplateLogsModal";
import {
  VIEW_AND_MIGRATE_TERM_ASSOCIATED_DATA_MODAL,
  RATINGS_LOGS_MODAL,
  REMARKS_LOGS_MODAL,
  TEMPLATE_LOGS_MODAL,
} from "./modules/InternalToolsModalConstants";

// Styles
import classes from "./InternalToolsModal.scss";

const InternalToolsModal = props => {
  const { closeInternalToolModal, modalType, modalData } = props;

  const renderModal = () => {
    switch (modalType) {
      case VIEW_AND_MIGRATE_TERM_ASSOCIATED_DATA_MODAL:
        return <ViewAndMigrateTermAssociatedData data={modalData} />;
      case RATINGS_LOGS_MODAL:
        return <RatingLogsModal data={modalData} />;
      case REMARKS_LOGS_MODAL:
        return <RemarkLogsModal data={modalData} />;
      case TEMPLATE_LOGS_MODAL:
        return <TemplateLogsModal data={modalData} />;
      default:
        return null;
    }
  };

  return (
    <DSProvider dsVersion={"2.0"}>
      <UIModal isOpen isFullScreen>
        <div className={classes.internalToolsContainer}>
          <PageHeader>
            <PageHeader.Left
              title={"Internal Tools"}
              onBackClick={closeInternalToolModal}
            />
          </PageHeader>
          {renderModal()}
        </div>
      </UIModal>
    </DSProvider>
  );
};

const mapStateToProps = state => {
  const modalType = _.get(state, "internal_tools.type", "");
  const modalData = _.get(state, "internal_tools.data", {});

  return {
    modalType,
    modalData,
  };
};

const mapActionCreators = {
  closeInternalToolModal,
};

export default compose(connect(mapStateToProps, mapActionCreators))(
  InternalToolsModal
);
